<template>
    <div class="course">
        <Top :title="title"></Top>
        <div class="s_banner">
            <img src="../../../assets/images/s_banner_2.jpg" alt=""/>
        </div>
        <Column title="学科分类">
            <Subject :list="sList"></Subject>    
        </Column>
        <div class="no-data-pad" v-if="dataList.length === 0"></div>
        <div class="line" v-if="dataList.length > 0"></div>
        <Column title="最新课程" v-if="dataList.length > 0">
            <ImgList :list="dataList"></ImgList>
        </Column>
        <Loading :show="isUa && isLoading"></Loading>
    </div>
</template>

<script>
import jsonp from 'jsonp'
import Top from './module/top'
import Subject from './module/subjectList'
import ImgList from './module/imgList'
import Column from "../column";
import Loading from "../../loading"
import util from '../../../util'
import subject1 from "../../../assets/images/subject_1.jpg";
import subject2 from "../../../assets/images/subject_2.jpg";
import subject3 from "../../../assets/images/subject_3.jpg";
import subject4 from "../../../assets/images/subject_4.jpg";
import subject5 from "../../../assets/images/subject_5.jpg";
import subject6 from "../../../assets/images/subject_6.jpg";
import subject7 from "../../../assets/images/subject_7.jpg";
import subject8 from "../../../assets/images/subject_8.jpg";
import subject9 from "../../../assets/images/subject_9.jpg";
import subject10 from "../../../assets/images/subject_10.png";
import subject11 from "../../../assets/images/subject_11.png";
import subject12 from "../../../assets/images/subject_12.png";
import subject13 from "../../../assets/images/subject_13.jpg";
import subject14 from "../../../assets/images/subject_14.png";
import subject15 from "../../../assets/images/subject_15.png";
import subject16 from "../../../assets/images/subject_16.png";
import subject17 from "../../../assets/images/subject_17.jpg";

export default{
    name: 'Course',
    data(){
        return{
            title: this.$route.params.title,
            sortid: this.$route.params.sortid,
            primarySchool: [50946,50947,50948,50949,50950,50951].join(','),     //小学
            juniorHighSchool: [50952,50953,50954].join(','),    //初中
            highSchool: [50955,50956,50957].join(','),  //高中
            isUa: window.navigator.userAgent.indexOf('ZgApp') < 0,
            isLoading: false,
            dataList: [],
            sList: [],   //科目
            primary: [
                {
                    link: `#/teachList/${encodeURI('语文')}/${this.$route.params.sortid}`,
                    gradeName: '',
                    image: subject1
                },
                {
                    link: `#/teachList/${encodeURI('数学')}/${this.$route.params.sortid}`,
                    gradeName: '',
                    image: subject2 
                },
                {
                    link: `#/teachList/${encodeURI('英语')}/${this.$route.params.sortid}`,
                    gradeName: '',
                    image: subject3
                },
                {
                    link: `#/teachList/${encodeURI('美术')}/${this.$route.params.sortid}`,
                    gradeName: '',
                    image: subject12
                },
                {
                    link: `#/teachList/${encodeURI('疫情教育')}/${this.$route.params.sortid}`,
                    gradeName: '',
                    image: subject11
                },
                {
                    link: `#/teachList/${encodeURI('德育学堂')}/${this.$route.params.sortid}`,
                    gradeName: '',
                    image: subject13
                },
                {
                    link: `#/teachList/${encodeURI('音乐')}/${this.$route.params.sortid}`,
                    gradeName: '',
                    image: subject14
                },
                {
                    link: `#/teachList/${encodeURI('心理')}/${this.$route.params.sortid}`,
                    gradeName: '',
                    image: subject15
                },
                {
                    link: `#/teachList/${encodeURI('安全教育')}/${this.$route.params.sortid}`,
                    gradeName: '',
                    image: subject17
                }
            ],
            juniorHigh: [
                {
                    link: `#/teachList/${encodeURI('语文')}/${this.$route.params.sortid}`,
                    gradeName: '',
                    image: subject1
                },
                {
                    link: `#/teachList/${encodeURI('数学')}/${this.$route.params.sortid}`,
                    gradeName: '',
                    image: subject2 
                },
                {
                    link: `#/teachList/${encodeURI('英语')}/${this.$route.params.sortid}`,
                    gradeName: '',
                    image: subject3
                },
                {
                    link: `#/teachList/${encodeURI('化学')}/${this.$route.params.sortid}`,
                    gradeName: '',
                    image: subject4
                },
                {
                    link: `#/teachList/${encodeURI('物理')}/${this.$route.params.sortid}`,
                    gradeName: '',
                    image: subject5
                },
                {
                    link: `#/teachList/${encodeURI('生物')}/${this.$route.params.sortid}`,
                    gradeName: '',
                    image: subject6
                },
                {
                    link: `#/teachList/${encodeURI('历史')}/${this.$route.params.sortid}`,
                    gradeName: '',
                    image: subject7
                },
                {
                    link: `#/teachList/${encodeURI('地理')}/${this.$route.params.sortid}`,
                    gradeName: '',
                    image: subject8
                },
                {
                    link: `#/teachList/${encodeURI('体育')}/${this.$route.params.sortid}`,
                    gradeName: '',
                    image: subject10
                },
                {
                    link: `#/teachList/${encodeURI('音乐')}/${this.$route.params.sortid}`,
                    gradeName: '',
                    image: subject14
                },
                {
                    link: `#/teachList/${encodeURI('美术')}/${this.$route.params.sortid}`,
                    gradeName: '',
                    image: subject12
                },
                {
                    link: `#/teachList/${encodeURI('疫情教育')}/${this.$route.params.sortid}`,
                    gradeName: '',
                    image: subject11
                },
                {
                    link: `#/teachList/${encodeURI('德育学堂')}/${this.$route.params.sortid}`,
                    gradeName: '',
                    image: subject13
                },
                {
                    link: `#/teachList/${encodeURI('道德与法治')}/${this.$route.params.sortid}`,
                    gradeName: '',
                    image: subject16
                },
                {
                    link: `#/teachList/${encodeURI('心理')}/${this.$route.params.sortid}`,
                    gradeName: '',
                    image: subject15
                },
                {
                    link: `#/teachList/${encodeURI('安全教育')}/${this.$route.params.sortid}`,
                    gradeName: '',
                    image: subject17
                }
            ],
            highSchoolList: [
                {
                    link: `#/teachList/${encodeURI('语文')}/${this.$route.params.sortid}`,
                    gradeName: '',
                    image: subject1
                },
                {
                    link: `#/teachList/${encodeURI('数学')}/${this.$route.params.sortid}`,
                    gradeName: '',
                    image: subject2 
                },
                {
                    link: `#/teachList/${encodeURI('英语')}/${this.$route.params.sortid}`,
                    gradeName: '',
                    image: subject3
                },
                {
                    link: `#/teachList/${encodeURI('化学')}/${this.$route.params.sortid}`,
                    gradeName: '',
                    image: subject4
                },
                {
                    link: `#/teachList/${encodeURI('物理')}/${this.$route.params.sortid}`,
                    gradeName: '',
                    image: subject5
                },
                {
                    link: `#/teachList/${encodeURI('生物')}/${this.$route.params.sortid}`,
                    gradeName: '',
                    image: subject6
                },
                {
                    link: `#/teachList/${encodeURI('历史')}/${this.$route.params.sortid}`,
                    gradeName: '',
                    image: subject7
                },
                {
                    link: `#/teachList/${encodeURI('地理')}/${this.$route.params.sortid}`,
                    gradeName: '',
                    image: subject8
                },
                {
                    link: `#/teachList/${encodeURI('政治')}/${this.$route.params.sortid}`,
                    gradeName: '',
                    image: subject9
                },
                {
                    link: `#/teachList/${encodeURI('体育')}/${this.$route.params.sortid}`,
                    gradeName: '',
                    image: subject10
                },
                {
                    link: `#/teachList/${encodeURI('音乐')}/${this.$route.params.sortid}`,
                    gradeName: '',
                    image: subject14
                },
                {
                    link: `#/teachList/${encodeURI('疫情教育')}/${this.$route.params.sortid}`,
                    gradeName: '',
                    image: subject11
                },
                {
                    link: `#/teachList/${encodeURI('德育学堂')}/${this.$route.params.sortid}`,
                    gradeName: '',
                    image: subject13
                },
                {
                    link: `#/teachList/${encodeURI('心理')}/${this.$route.params.sortid}`,
                    gradeName: '',
                    image: subject15
                },
                {
                    link: `#/teachList/${encodeURI('安全教育')}/${this.$route.params.sortid}`,
                    gradeName: '',
                    image: subject17
                }
            ]
        }
    },
    created(){
        this.getData(this.title);
        this.getStatistPv();
        this.getSubject();
    },
    mounted(){
        util.jumpLink();
    },
    methods:{
        getSubject(){
            let idStr = '';
            if(this.primarySchool.indexOf(this.sortid) >= 0){
                this.sList = this.primary;
            }
            if(this.juniorHighSchool.indexOf(this.sortid) >= 0){
                this.sList = this.juniorHigh;
            }
            if(this.highSchool.indexOf(this.sortid) >= 0){
                this.sList = this.highSchoolList;
            }
        },
        getData(name){
            // let idArr = [];
            // switch(name){
            //     case '小学教育':
            //         idArr = [50946,50947,50948,50949,50950,50951].join(',');
            //         break;
            //     case '初中教育':
            //         idArr = [50952,50953,50954].join(',');
            //         break;
            //     case '高中教育':
            //         idArr = [50955,50956,50957].join(',');
            //         break;
            //     default:
            //         idArr = this.sortid;
            //         break;
            // } 
            // this.isLoading = true;          
            // jsonp(`https://v.gxnews.com.cn/?c=json&a=course_list&sortids=${idArr}&limit=100`, {} , (err, data) => {
            //     if (err) {
            //         console.error(err.message);
            //     } else {
            //         this.isLoading = false;
            //         this.dataList = data.courselist;
            //     }
            // })
            this.isLoading = true;
            this.axios.get(`/data/${this.sortid}.json?t=${Math.round(new Date().getTime()/100000)}`).then((res) => {
                this.isLoading = false;
                this.dataList = res.data.courselist;
            })
        },
        getStatistPv(){
            jsonp(`https://dcy.gxnews.com.cn/insert.php?myurl=http%3a%2f%2fbyte.gxnews.com.cn%2fzg%2f%23%2fclassifiy/${encodeURI(this.title)}/${this.sortid}&sid=${this.sortid}&tag=zgapp&t=${Math.random()}`, {} , (err, data) => {
                if (err) {
                    console.error(err.message);
                } else {
                    console.log('请求成功');
                }
            })   
        }
    },
    components:{
        Top,
        Subject,
        ImgList,
        Column,
        Loading    
    }
}
</script>

<style lang="less" scoped>
    .course{
        padding-top: 1rem;
        .s_banner{
            margin-bottom: 0.35rem;
            img{
                width: 100%;
            }
        }
        .line{
            height: 0.25rem;
            margin: 0.2rem 0 0.3rem 0;
            background: #f3f3f3;
        }
        .no-data-pad{
            padding-bottom: 1.5rem;
        }
    }             
</style>   